import React, { useState, useEffect } from 'react';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const GlobalFooter = () => {
  const [settings, setSettings] = useState({
    text: 'DESIGNED By ictglobalinitiatives & WHICHBusiness.CANADA',
    links: [],
    show_social: false,
    social_links: {},
    background_color: '#f9fafb',
    text_color: '#6b7280',
    font_size: '14',
    font_family: 'Inter',
    text_alignment: 'center'
  });

  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const res = await fetch(`${API_URL}/api/footer`);
        if (res.ok) {
          const data = await res.json();
          setSettings({
            text: data.text || 'DESIGNED By ictglobalinitiatives & WHICHBusiness.CANADA',
            links: data.links || [],
            show_social: data.show_social || false,
            social_links: data.social_links || {},
            background_color: data.background_color || '#f9fafb',
            text_color: data.text_color || '#6b7280',
            font_size: data.font_size || '14',
            font_family: data.font_family || 'Inter',
            text_alignment: data.text_alignment || 'center'
          });
        }
      } catch (error) {
        console.error('Error fetching footer settings:', error);
      }
    };
    fetchFooterSettings();
  }, []);

  const alignmentClass = settings.text_alignment === 'center' ? 'justify-center' : 
    settings.text_alignment === 'right' ? 'justify-end' : 'justify-start';

  return (
    <footer 
      className="w-full py-4 px-6 border-t"
      style={{ backgroundColor: settings.background_color }}
      data-testid="global-footer"
    >
      <div className="max-w-7xl mx-auto">
        <div style={{ textAlign: settings.text_alignment }}>
          {/* Links */}
          {settings.links.length > 0 && (
            <div className={`flex items-center gap-4 mb-3 flex-wrap ${alignmentClass}`}>
              {settings.links.map((link, index) => (
                <a
                  key={index}
                  href={link.url || '#'}
                  className="hover:underline transition-colors"
                  style={{ 
                    color: settings.text_color,
                    fontFamily: settings.font_family,
                    fontSize: `${settings.font_size}px`
                  }}
                  target={link.url?.startsWith('http') ? '_blank' : '_self'}
                  rel={link.url?.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  {link.label}
                </a>
              ))}
            </div>
          )}
          
          {/* Social Media Icons */}
          {settings.show_social && (
            <div className={`flex items-center gap-4 mb-3 ${alignmentClass}`}>
              {settings.social_links.facebook && (
                <a 
                  href={settings.social_links.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <Facebook className="w-5 h-5" style={{ color: settings.text_color }} />
                </a>
              )}
              {settings.social_links.twitter && (
                <a 
                  href={settings.social_links.twitter} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <Twitter className="w-5 h-5" style={{ color: settings.text_color }} />
                </a>
              )}
              {settings.social_links.instagram && (
                <a 
                  href={settings.social_links.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <Instagram className="w-5 h-5" style={{ color: settings.text_color }} />
                </a>
              )}
              {settings.social_links.youtube && (
                <a 
                  href={settings.social_links.youtube} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-70 transition-opacity"
                >
                  <Youtube className="w-5 h-5" style={{ color: settings.text_color }} />
                </a>
              )}
            </div>
          )}
          
          {/* Main Text */}
          <p style={{ 
            color: settings.text_color,
            fontFamily: settings.font_family,
            fontSize: `${settings.font_size}px`
          }}>
            {settings.text}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
